
 export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'text'
      },
      element: null, 
      rect: {
        type: Object,
        default: () => ({
          top: 0,
          left: 0,
          width: 100,
          height: 100
        })
      },
    },
    data() {
      return {
        hoverBoxConfig: {
          editable: {
            label: '基础块'
          },
          text: {
            label: '文本'
          },
          image: {
            label: '图像'
          },
          video: {
            label: '视频'
          },
          list: {
            label: '列表'
          },
          item: {
            label: '列表项'
          }
        }
      }
    }
  }
